export default __webpack_public_path__ + "img/49655cc02b9a0967991e2242959f0f30.svg";